window.global = window.globalThis;

export {};
